import PropTypes from 'prop-types';
import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import styles from './NoAuthResultsMessage.module.scss';
import logo from './logo.svg';

class NoAuthResultsMessage extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    role: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      roleSelected: props.location ? props.location.query.role : props.role,
    };
  }

  render() {
    const CTALink = this.state.roleSelected
      ? `/post-a-job?role=${this.state.roleSelected}`
      : '/post-a-job';

    return (
      <div
        className={styles.container}
        style={{
          marginTop: 50,
          padding: 10,
          paddingTop: 50,
          paddingBottom: 50,
        }}
      >
        <div className={styles.logo}>
          <img className={styles.logoImage} src={logo} alt="Twine" />
        </div>
        <div className={`text-center ${styles.copy}`}>
          <p className="fs-18">
            Connect with our global network and bring the freelancers to you.
          </p>
          <Button className="mt fs-15" bsStyle="success" href={CTALink}>
            Post a project
          </Button>
        </div>
      </div>
    );
  }
}
export default NoAuthResultsMessage;
